import React from 'react';
import compose from '../../hoc/compose';
import PropTypes from 'prop-types';
var illustration = function illustration(props) {
  var newProps = {
    className: props.getClassName('control-illustration'),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  };
  return /*#__PURE__*/React.createElement('div', newProps, props.children);
};
illustration.displayName = 'Illustration';
illustration.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string
};
export default compose(illustration);